import classnames from 'classnames';
import { ECG_DISCLOSURE } from '@/shared/config';
import DeviceEventWrapper from '../deviceEventWrapper';
import ManageStripsWrapper from '../manageStripsWrapper';
import EcgDisclosure from '../ecgDisclosure';
import useWrapReport from './useWrapReport';

export type WrapReportProps = {
  reportData?: any;
  timezoneOffset?: any;
  isActive?: boolean;
  isNotEdit?: boolean;
};

/**
 * Composes the strips management tab, keeping the device events, ECG disclosure and manage-strips panels mounted and toggling their visibility. Reads the active sub-tab and ECG data map from useWrapReport, hides each panel with a CSS class rather than unmounting it, and feeds study, profile and report window values down from reportData.
 *
 * @param props - Report data, timezone offset and the isActive and isNotEdit flags for the tab.
 * @returns The strips management tab layout with all three panels mounted.
 */
const WrapReport = ({ reportData, timezoneOffset, isActive, isNotEdit }: WrapReportProps) => {
  const { activeButton, ecgDataMap, isDeviceEvent, isShowTabHeader } = useWrapReport({
    reportData,
  });

  return (
    <div className={classnames('strip-management-tab', isShowTabHeader ? '' : '--hide-tab')}>
      <div className={classnames(!isDeviceEvent ? 'hide-strip-management' : '')}>
        <DeviceEventWrapper reportData={reportData} isActive={isActive} />
      </div>
      <div
        className={classnames(
          'ecg-disclosure-tab',
          (activeButton as any) !== ECG_DISCLOSURE ? 'hide-strip-management' : '',
        )}
      >
        <EcgDisclosure
          isActive={(activeButton as any) === ECG_DISCLOSURE && isActive}
          ecgDataMap={ecgDataMap}
          timezoneOffset={timezoneOffset}
          studyId={reportData?.study?.id}
          profileId={reportData?.holterProfile?.id}
          startReport={reportData?.holterProfile?.start}
          stopReport={reportData?.holterProfile?.stop}
        />
      </div>

      <div
        className={classnames(
          (activeButton as any) === ECG_DISCLOSURE || isDeviceEvent ? 'hide-strip-management' : '',
        )}
      >
        <ManageStripsWrapper
          reportData={reportData}
          studyId={reportData?.study?.id}
          profileId={reportData?.holterProfile?.id}
          isActive={isActive}
          isNotEdit={isNotEdit}
        />
      </div>
    </div>
  );
};

export default WrapReport;
